import * as React from "react";
const SvgFiRrSpaceStationMoonAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M19.5 13h-1.699a9 9 0 0 0-2.221-4.166l1.517-1.517A7.96 7.96 0 0 0 22 9a1 1 0 1 0 0-2c-3.309 0-6-2.691-6-6a1 1 0 1 0-2 0 7.96 7.96 0 0 0 1.683 4.903l-1.632 1.632A9 9 0 0 0 10 6.053V5a1 1 0 1 0-2 0v1.055c-4.51.501-8 4.495-8 9.231V18.5C0 20.981 2.019 23 4.5 23h15c2.481 0 4.5-2.019 4.5-4.5v-1c0-2.481-2.019-4.5-4.5-4.5M2 18.5v-3.214c0-3.803 2.836-6.994 6.456-7.266a7.05 7.05 0 0 1 7.278 4.987A5.006 5.006 0 0 0 11 18v3H4.5A2.5 2.5 0 0 1 2 18.5m20 0c0 1.379-1.121 2.5-2.5 2.5H13v-3c0-1.654 1.346-3 3-3h3.5c1.379 0 2.5 1.121 2.5 2.5zM8 16v1a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1"
    />
  </svg>
);
export default SvgFiRrSpaceStationMoonAlt;
